import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.items = [...this.el.querySelectorAll('.o-header_item')]
    this.over = [...this.el.querySelectorAll('.o-header_item_over')]
    this.icon = this.el.querySelector('.o-header_icon')
    this.zindex = 1
    this.mouseEnter = this.mouseEnter.bind(this)
    this.mouseLeave = this.mouseLeave.bind(this)

    this.over.forEach((elt) => {
      elt.addEventListener(
        'mouseenter',
        this.mouseEnter,
        { passive: true }
      )
      elt.addEventListener(
        'mouseleave',
        this.mouseLeave,
        { passive: true }
      )
    })
  }

  mouseEnter(e) {
    this.zindex++

    const index = e.target.getAttribute('data-index')

    this.items[index].classList.add('-visible')
    this.items[index].style.zIndex = this.zindex

    this.items.forEach((elt) => {
      if (elt.getAttribute('data-index') !== index) {
        elt.classList.add('-hidden')
      }
    })

    this.over.forEach((elt) => {
      elt.style.zIndex = this.zindex + 1
    })

    this.icon.classList.add('-hidden')
    this.icon.style.zIndex = this.zindex + 1
  }

  mouseLeave(e) {
    const index = e.target.getAttribute('data-index')

    this.items[index].classList.remove('-visible')
    this.items.forEach((elt) => {
      elt.classList.remove('-hidden')
    })
    this.icon.classList.remove('-hidden')
  }

  destroy() {
    this.over.forEach((elt) => {
      elt.removeEventListener('mouseenter', this.mouseEnter)
      elt.removeEventListener('mouseleave', this.mouseLeave)
    })
  }
}
